module.exports = __webpack_public_path__ + "img/button_user_circle.5c6196e9.png";